var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84307 1.14575C3.51976 1.14575 3.20969 1.27419 2.98107 1.5028C2.75246 1.73142 2.62402 2.04149 2.62402 2.3648V12.1172C2.62402 12.4405 2.75246 12.7506 2.98107 12.9792C3.20969 13.2078 3.51976 13.3362 3.84307 13.3362H11.5637C11.887 13.3362 12.1971 13.2078 12.4257 12.9792C12.6543 12.7506 12.7828 12.4405 12.7828 12.1172V6.01077C12.7828 5.64048 12.6355 5.28543 12.3739 5.02334L8.85336 1.50283C8.62475 1.27421 8.31469 1.14577 7.99139 1.14575H3.84307ZM3.38593 2.3648C3.38593 2.24356 3.43409 2.12728 3.51982 2.04155C3.60555 1.95582 3.72183 1.90766 3.84307 1.90766H7.70339V5.20924C7.70339 5.47867 7.81042 5.73706 8.00093 5.92757C8.19144 6.11809 8.44983 6.22512 8.71926 6.22512H12.0208V12.1172C12.0208 12.2384 11.9727 12.3547 11.887 12.4404C11.8012 12.5262 11.6849 12.5743 11.5637 12.5743H3.84307C3.72183 12.5743 3.60555 12.5262 3.51982 12.4404C3.43409 12.3547 3.38593 12.2384 3.38593 12.1172V2.3648ZM11.7364 5.46321H8.71926C8.6519 5.46321 8.58731 5.43645 8.53968 5.38883C8.49205 5.3412 8.46529 5.2766 8.46529 5.20924V2.1921L11.7364 5.46321Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.791ed3e2f2ac723006d53fcaa075a67c.svg";
export { ForwardRef as ReactComponent };